const flatten = arr => arr.reduce((flat, val) => flat.concat(val), [])

export default flatten



// WEBPACK FOOTER //
// ./src/utilities/flatten.js